import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

export default function Navbar() {
  return (
    <nav className="navbar">
      <div className="logo">☕ פרי מטיב</div>
      <div className="nav-links">
        <Link to="/">בית</Link>
        <Link to="/menu">תפריט</Link>
        <Link to="/about">אודות</Link>
      </div>
    </nav>
  );
}
